import styled, { css } from 'styled-components';

// RadioIndicator must be defined first since RadioInput references it
export var RadioIndicator = /*#__PURE__*/styled.span.withConfig({
  displayName: "Radiostyles__RadioIndicator",
  componentId: "sc-mnfdx1-0"
})(["display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:50%;border:", " solid ", ";background-color:transparent;flex-shrink:0;box-sizing:border-box;transition:border-color 50ms ease-out,border-width 50ms ease-out,background-color 50ms ease-out,box-shadow 50ms ease-out;", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.kallisto.border.width.width12;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.kallisto.color.border.interactive.borderNeutralDefault;
}, function (_ref3) {
  var $disabled = _ref3.$disabled,
    theme = _ref3.theme;
  return $disabled && css(["border-color:", ";"], theme.kallisto.color.border.static.borderDisabled);
}, function (_ref4) {
  var $hasError = _ref4.$hasError,
    $disabled = _ref4.$disabled,
    theme = _ref4.theme;
  return $hasError && !$disabled && css(["border-color:", ";background-color:", ";"], theme.kallisto.color.border.static.borderErrorContrast, theme.kallisto.color.background.static.backgroundErrorSubtle);
});
export var RadioInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "Radiostyles__RadioInput",
  componentId: "sc-mnfdx1-1"
})(["opacity:0;position:absolute;width:0;height:0;margin:0;padding:0;&:checked + ", "{border-width:5px;border-color:", ";background-color:transparent;}&:checked:disabled + ", "{border-color:", ";background-color:", ";}", " &:focus-visible + ", "{outline:2px ", " solid;outline-offset:0;box-shadow:0 0 0 4px ", ";border-color:", ";}&:focus-visible:checked + ", "{border-color:", ";}", ""], RadioIndicator, function (_ref5) {
  var theme = _ref5.theme;
  return theme.kallisto.color.background.interactive.backgroundBrandContrastDefault;
}, RadioIndicator, function (_ref6) {
  var theme = _ref6.theme;
  return theme.kallisto.color.background.static.backgroundDisabled;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.kallisto.color.icon.static.iconDisabled;
}, function (_ref8) {
  var $hasError = _ref8.$hasError,
    theme = _ref8.theme;
  return $hasError && css(["&:checked + ", "{border-width:", ";border-color:", ";background-color:", ";}"], RadioIndicator, theme.kallisto.border.width.width12, theme.kallisto.color.border.static.borderErrorContrast, theme.kallisto.color.background.static.backgroundErrorSubtle);
}, RadioIndicator, function (_ref9) {
  var theme = _ref9.theme;
  return theme.kallisto.color.common.white[1000];
}, function (_ref0) {
  var theme = _ref0.theme;
  return theme.kallisto.color.common.black[1000];
}, function (_ref1) {
  var theme = _ref1.theme;
  return theme.kallisto.color.border.interactive.borderNeutralHover;
}, RadioIndicator, function (_ref10) {
  var theme = _ref10.theme;
  return theme.kallisto.color.background.interactive.backgroundBrandContrastHover;
}, function (_ref11) {
  var $hasError = _ref11.$hasError,
    theme = _ref11.theme;
  return $hasError && css(["&:focus-visible + ", "{border-color:", ";background-color:", ";}"], RadioIndicator, theme.kallisto.color.border.static.borderErrorContrast, theme.kallisto.color.background.static.backgroundLayer02);
});
export var RadioLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "Radiostyles__RadioLabel",
  componentId: "sc-mnfdx1-2"
})(["font-family:", ";font-size:", ";line-height:", ";color:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.kallisto.font.family.sans;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.kallisto.font.size[175];
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.kallisto.font.lineHeight[200];
}, function (_ref15) {
  var theme = _ref15.theme,
    $disabled = _ref15.$disabled;
  return $disabled ? theme.kallisto.color.text.static.textDisabled : theme.kallisto.color.text.static.textPrimary;
});
export var SecondaryLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "Radiostyles__SecondaryLabel",
  componentId: "sc-mnfdx1-3"
})(["", ";color:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.kallisto.mixins.font('BodySmall');
}, function (_ref17) {
  var theme = _ref17.theme,
    $disabled = _ref17.$disabled;
  return $disabled ? theme.kallisto.color.text.static.textDisabled : theme.kallisto.color.text.static.textSecondary;
});
export var RadioLabelColumn = /*#__PURE__*/styled.span.withConfig({
  displayName: "Radiostyles__RadioLabelColumn",
  componentId: "sc-mnfdx1-4"
})(["display:inline-flex;flex-direction:column;align-items:flex-start;margin-left:", ";margin-right:", ";"], function (_ref18) {
  var theme = _ref18.theme,
    $radioOnTheRight = _ref18.$radioOnTheRight;
  return !$radioOnTheRight ? theme.kallisto.space.space100 : '0';
}, function (_ref19) {
  var theme = _ref19.theme,
    $radioOnTheRight = _ref19.$radioOnTheRight;
  return $radioOnTheRight ? theme.kallisto.space.space100 : '0';
});
export var RightRadioLabel = /*#__PURE__*/styled(RadioLabel).withConfig({
  displayName: "Radiostyles__RightRadioLabel",
  componentId: "sc-mnfdx1-5"
})(["margin-right:", ";"], function (_ref20) {
  var theme = _ref20.theme;
  return theme.kallisto.space.space100;
});
export var LeftRadioLabel = /*#__PURE__*/styled(RadioLabel).withConfig({
  displayName: "Radiostyles__LeftRadioLabel",
  componentId: "sc-mnfdx1-6"
})(["margin-left:", ";"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.kallisto.space.space100;
});
export var Label = /*#__PURE__*/styled.label.withConfig({
  displayName: "Radiostyles__Label",
  componentId: "sc-mnfdx1-7"
})(["position:relative;display:inline-flex;align-items:center;overflow:hidden;padding:", ";border-radius:", ";cursor:", ";transition:background-color 50ms ease-out;", " ", " ", " &:hover ", ":not(:disabled):not([data-error]) + ", "{border-color:", ";}&:hover ", ":checked:not(:disabled) + ", "{border-color:", ";}"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.kallisto.space.space100;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.kallisto.border.radius.radius100;
}, function (_ref24) {
  var $disabled = _ref24.$disabled;
  return $disabled ? 'default' : 'pointer';
}, function (_ref25) {
  var $withBorder = _ref25.$withBorder,
    $hasError = _ref25.$hasError,
    theme = _ref25.theme;
  return $withBorder ? css(["border:", " solid ", ";"], theme.kallisto.border.width.width12, $hasError ? theme.kallisto.color.border.static.borderErrorContrast : theme.kallisto.color.border.interactive.borderNeutralDefault) : '';
}, function (_ref26) {
  var $disabled = _ref26.$disabled,
    $hoverBackground = _ref26.$hoverBackground,
    $isHovered = _ref26.$isHovered,
    $hasError = _ref26.$hasError,
    theme = _ref26.theme;
  return !$disabled && !$hasError ? css(["", ""], $isHovered && css(["background-color:", ";", "{border-color:", ";}", ":checked + ", "{border-color:", ";}"], $hoverBackground ? theme.kallisto.color.background.interactive.backgroundNeutralHover : undefined, RadioIndicator, theme.kallisto.color.border.interactive.borderNeutralHover, RadioInput, RadioIndicator, theme.kallisto.color.background.interactive.backgroundBrandContrastHover)) : '';
}, function (_ref27) {
  var $hoverBackground = _ref27.$hoverBackground,
    $disabled = _ref27.$disabled,
    $hasError = _ref27.$hasError,
    theme = _ref27.theme;
  return $hoverBackground && !$disabled && !$hasError ? css(["&:hover{background-color:", ";}"], theme.kallisto.color.background.interactive.backgroundNeutralHover) : '';
}, RadioInput, RadioIndicator, function (_ref28) {
  var theme = _ref28.theme,
    $hasError = _ref28.$hasError;
  return $hasError ? theme.kallisto.color.border.static.borderErrorContrast : theme.kallisto.color.border.interactive.borderNeutralHover;
}, RadioInput, RadioIndicator, function (_ref29) {
  var theme = _ref29.theme,
    $hasError = _ref29.$hasError;
  return $hasError ? theme.kallisto.color.border.static.borderErrorContrast : theme.kallisto.color.background.interactive.backgroundBrandContrastHover;
});